import { colors } from '@packages/core/styles';
import { Icon, Typography } from '@packages/ui/shared';
import { TableHeader, TableRow } from '@web/components/table';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    tableHeader: {
        height: 40,
    },
    center: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
    },
    tooltip: {
        marginTop: 5,
        width: 232,
        '& .tooltip-inner': {
            backgroundColor: colors.brandSecondary,
            borderRadius: 4,
            fontSize: '13px',
            fontWeight: 400,
            lineHeight: '16px',
            maxWidth: 232,
            padding: '3px 8px',
            textAlign: 'left',
        },
    },
});

/**
 * Renders the table header row for the DTC codes table with DTC, Primary, and Freeze Frame columns.
 *
 * @returns the DTC codes table header row
 */
export function DtcCodesTableHead() {
    const classes = useStyles();
    return (
        <TableRow>
            <TableHeader className={classes.tableHeader} width="40%">
                <Typography variant="caption">DTC</Typography>
            </TableHeader>
            <TableHeader className={classes.tableHeader} width="25%">
                <div className="d-flex align-items-center justify-content-between gap-1">
                    <Typography variant="caption">Primary</Typography>
                    <OverlayTrigger
                        overlay={
                            <Tooltip className={classes.tooltip} id="dtc-primary-col-info-tool">
                                <Icon color="white" name="star-filled" size={14} /> Select which DTC is the primary.
                                Only one DTC can be selected as primary.
                            </Tooltip>
                        }
                        placement="right"
                    >
                        <Icon color="grayFive" name="info" size={16} />
                    </OverlayTrigger>
                </div>
            </TableHeader>
            <TableHeader className={`${classes.tableHeader} ${classes.center}`} width="35%">
                <Typography variant="caption">Mark Freeze Frame Data in SSM</Typography>
            </TableHeader>
        </TableRow>
    );
}
